import { PresenceRejet } from '../SANDRE/presense-rejet';

export class QualiteVisuelleEau {
    id: number; // For IndexedDB
    interventionId: number;
    
    Irisation: boolean;
    PresenceMousseDetergent: boolean;
    PresenceDebrisLigneuxFrais: boolean;
    PresenceBoueOrgaFlottante: boolean;
    PresenceAutresCorps: boolean;
    PositionRejetEventuel: boolean;
    NatureRejet: string;
    PresenceRejet: PresenceRejet;

    static mapFromJSON(json: any): QualiteVisuelleEau {
        const m = new QualiteVisuelleEau();

        m.Irisation = json.irisation;
        m.PresenceAutresCorps = json.presenceAutresCorps;
        m.PresenceBoueOrgaFlottante = json.presenceBoueOrgaFlottante;
        m.PresenceDebrisLigneuxFrais = json.presenceDebrisLigneuxFrais;
        m.PresenceMousseDetergent = json.presenceMousseDetergent;
        m.PositionRejetEventuel = json.positionRejetEventuel;
        m.NatureRejet = json.natureRejet;
        m.PresenceRejet = json.presenceRejet;

        return m;
    }
}
